module.exports = __webpack_public_path__ + "static/img/feedbackhome.2cd6d0bc.jpg";